import {registerRoute as workbox_routing_registerRoute} from '/Users/adamt/Repos/app3/builds/afcpe-common/node_modules/workbox-routing/registerRoute.mjs';
import {NetworkFirst as workbox_strategies_NetworkFirst} from '/Users/adamt/Repos/app3/builds/afcpe-common/node_modules/workbox-strategies/NetworkFirst.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/Users/adamt/Repos/app3/builds/afcpe-common/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/Users/adamt/Repos/app3/builds/afcpe-common/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/Users/adamt/Repos/app3/builds/afcpe-common/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/cdn/afcpe-common/js/@dojo/loader/loader.js",
    "revision": "f66a38c73e036053cd0d1f928cb24e38"
  },
  {
    "url": "/cdn/afcpe-common/js/core-js/polyfill.js",
    "revision": "149d609e92b0f722f6318e724ee932bd"
  },
  {
    "url": "/cdn/afcpe-common/js/main.14cb865e74147125975d.js",
    "revision": null
  },
  {
    "url": "/cdn/afcpe-common/js/packages_node_modules_dojo_widgets_calendar_nls_zh-CN_Calendar_mjs.2f47648578d1cfaa324b.js",
    "revision": null
  },
  {
    "url": "/cdn/afcpe-common/js/packages_node_modules_dojo_widgets_calendar_nls_zh-TW_Calendar_mjs.1d1d4f76469151ea732f.js",
    "revision": null
  },
  {
    "url": "/cdn/afcpe-common/js/packages_node_modules_dojo_widgets_dialog_nls_zh-CN_Dialog_mjs.bd373a462899b476cf2b.js",
    "revision": null
  },
  {
    "url": "/cdn/afcpe-common/js/packages_node_modules_dojo_widgets_dialog_nls_zh-TW_Dialog_mjs.dbd7527e1e44bae83c19.js",
    "revision": null
  },
  {
    "url": "/cdn/afcpe-common/js/packages_node_modules_holmescorp_base-widgets_date-input_nls_fr-CA_DateInput_js.e64b4c9ca9d807f98fdf.js",
    "revision": null
  },
  {
    "url": "/cdn/afcpe-common/js/packages_node_modules_holmescorp_base-widgets_date-input_nls_zh-CN_DateInput_js.2e1f8b7f94f5d482b5b6.js",
    "revision": null
  },
  {
    "url": "/cdn/afcpe-common/js/packages_node_modules_holmescorp_base-widgets_date-input_nls_zh-TW_DateInput_js.b1389d1849ac36c2e905.js",
    "revision": null
  },
  {
    "url": "/cdn/afcpe-common/js/packages_node_modules_holmescorp_base-widgets_sliding-pane_nls_zh-CN_index_js.79826281de8db27568fa.js",
    "revision": null
  },
  {
    "url": "/cdn/afcpe-common/js/packages_node_modules_holmescorp_base-widgets_sliding-pane_nls_zh-TW_index_js.0223badf9d6f7e0f1a33.js",
    "revision": null
  },
  {
    "url": "/cdn/afcpe-common/js/packages_node_modules_holmescorp_base-widgets_tab-container_nls_zh-CN_index_js.5d58018743c0863b3efe.js",
    "revision": null
  },
  {
    "url": "/cdn/afcpe-common/js/packages_node_modules_holmescorp_base-widgets_tab-container_nls_zh-TW_index_js.6818873de683b1f421d7.js",
    "revision": null
  },
  {
    "url": "/cdn/afcpe-common/js/packages_node_modules_holmescorp_search-widget_main_js.c9e5a05741d8aa16bab3.js",
    "revision": null
  }
], {});




workbox_routing_registerRoute(/.+\/$/, new workbox_strategies_NetworkFirst({ "cacheName":"acfpe-site", plugins: [] }), 'GET');
workbox_routing_registerRoute(/.+\/js\/sitestart\.js$/, new workbox_strategies_NetworkFirst({ "cacheName":"acfpe-site", plugins: [] }), 'GET');
workbox_routing_registerRoute(/.+\.(?:jpg|jpeg|png|svg|ttf|woff|woff2|eot|ico)$/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"acfpe-site", plugins: [] }), 'GET');
workbox_routing_registerRoute(/.+\.css$/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"acfpe-site", plugins: [] }), 'GET');




